import { Link } from "react-router-dom";

export function PageHero({ eyebrow, title, copy, image, page }) {
  return (
    <section className="page-hero" style={{ "--page-image": `url("${image}")` }} data-testid={`${page}-hero`}>
      <div className="page-hero__content">
        <nav aria-label="Breadcrumb" data-testid={`${page}-breadcrumb`}><Link to="/" data-testid={`${page}-breadcrumb-home-link`}>Início</Link><span>/</span><span>{page}</span></nav>
        <p className="eyebrow eyebrow--light" data-testid={`${page}-hero-eyebrow`}>{eyebrow}</p>
        <h1 data-testid={`${page}-hero-title`}>{title}</h1>
        <p data-testid={`${page}-hero-copy`}>{copy}</p>
      </div>
    </section>
  );
}